var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOm = function SvgIconOm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12c0 4.549 2.53 8.506 6.26 10.541V1.46A12 12 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.254 16.175c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174H.746A12 12 0 0 0 0 12.001c0 1.468.264 2.874.746 4.174L12 17.218z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24c5.16 0 9.559-3.257 11.254-7.826H.747C2.443 20.744 6.841 24 12.001 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12c0 5.544 3.76 10.21 8.87 11.586V.413C3.76 1.79 0 6.455 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.342 5.282 6.235 4.175l-.738.738-.738-.738-1.107 1.107.738.737-.738.738L4.76 7.864l.738-.738.738.738 1.107-1.107-.738-.738z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconOm;